import type { ReactElement, ReactNode } from 'react';
import { Card } from '@airtm/airtm-ui';
import cx from 'classnames';

type CustodialProviderCardProps = {
  selected?: boolean;
  description: string | ReactNode;
  brand: ReactElement;
  onClick?: () => void;
  selectable?: boolean;
  className?: string;
};

const CustodialProviderCard = function (props: CustodialProviderCardProps) {
  const {
    selected = false,
    selectable = false,
    brand,
    description,
    onClick = null,
    className = '',
  } = props;
  return (
    <Card
      className={cx(
        { 'card--hover cur--p': selectable },
        { 'card-action-radio--checked': selected },
        className,
      )}
      onClick={onClick}
    >
      <Card.Body className="u-px-3 u-py-4">
        {brand}
        <p className="text--md u-pt-1 m-0">{description}</p>
      </Card.Body>
    </Card>
  );
};
export default CustodialProviderCard;
